// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniCardV2_container__kDIMC","linkText":"MiniCardV2_linkText__PgsYb","textContainer":"MiniCardV2_textContainer__hcvcN","tagline":"MiniCardV2_tagline__7fsnd"};